/**
 * Light, dark, or whatever the device says.
 *
 * Lives wherever an app keeps the settings nobody touches mid-service: the
 * account sheet in the office, the terminal sheet on a till. "System" comes
 * first because it is the default and the answer most people should leave
 * alone — see `theme.ts` for why the device is followed in script rather than
 * in a media query.
 */

import { Segmented } from './primitives';
import { useTheme } from '../theme';

export function ThemePicker({ label = 'Appearance' }: { label?: string | undefined }) {
  const { choice, choose } = useTheme();

  return (
    <div className="ui-theme">
      <span className="ui-theme__label">{label}</span>
      <Segmented
        label={label}
        value={choice}
        onChange={choose}
        options={[
          { value: 'system', label: 'System' },
          { value: 'light', label: 'Light' },
          { value: 'dark', label: 'Dark' },
        ]}
      />
    </div>
  );
}
